import commonMixin from './_common';
import flashMessageMixin from './_flash_messages';

/**
 * oepning_progressフラグを取得、更新するメソッドを提供するミックスイン
 */
export default {
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    methods: {
        // 指定タスクが完了しているか
        isDoneTask: async function (column, task) {
            const guideStep = await this.getUserProgress(column);
            if (typeof guideStep[task] !== 'undefined' && guideStep[task]) {
                return true;
            }
            return false;
        },
        // 取得
        getUserProgress: async function (column = null) {
            let message = this.exception_error_message;
            let step = {};
            try {
                const response = await axios.get('/guide/user_progress');
                if (response.data.status === 'OK') {
                    if (column) {
                        step =  response.data.data[column];
                    } else {
                        step =  response.data.data;
                    }
                    message = '';
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            // エラーメッセージ
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            return step;
        },
        // 更新
        updateUserProgress: async function (column, task) {
            let message = this.exception_error_message;
            let success = false;
            try {
                this.$_loading();
                const response = await axios.post('/guide/user_progress', {
                    _method: 'PUT',
                    column: column,
                    task: task,
                });
                if (response.data.status === 'OK') {
                    message = '';
                    success = true;
                } else {
                    message = response.data.message;
                }
            } catch (e) {
                message = this.getCatchMessage(e);
            }
            this.$_unloading();
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$parent);
            }
            return success;
        },
    }
};
